import React, { Component } from 'react';
import styles from './index.module.scss';

class SearchProduct extends Component {
  render() {
    const { tips, name, buy_url, photo, ambulance } = this.props;
    return (
      <a className={styles.link} href={buy_url} target="view_window">
        <div className={styles.product}>
          <img src={ambulance + photo} className={styles.img} alt="" />
          <div className={styles.info}>
            <span className={styles.name}>{name}</span>
            <span className={styles.tips}>{tips}</span>
          </div>
        </div>
      </a>
    );
  }
}

export default SearchProduct;
